import { constantRoutes, mapRouter } from '@/router'
import Layout from '@/layout'
import MiddleLayout from '@/layout/MiddleLayout'
import { getButtons } from '@/api/buttonPermisson'

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
	if (route.meta && route.meta.roles) {
		return roles.some(role => route.meta.roles.includes(role))
	} else {
		return true
	}
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
	const res = []

	routes.forEach(route => {
		const tmp = { ...route }
		if (hasPermission(roles, tmp)) {
			if (tmp.children) {
				tmp.children = filterAsyncRoutes(tmp.children, roles)
			}
			res.push(tmp)
		}
	})

	return res
}

const state = {
	routes: [],
	addRoutes: [],
	permissionButtonMap: null // 按钮权限MAP
}

const mutations = {
	SET_ROUTES: (state, routes) => {
		state.addRoutes = routes
		state.routes = constantRoutes.concat(routes)
	},
	// 按钮权限存入store
	SET_PERMISSION_BUTTON_MAP: (state, { id, data }) => {
    const map = new Map()
		map.set(Number(id), data || [])
		state.permissionButtonMap = map
	}
}

const actions = {
	generateRoutes({ commit }, { menu, quickBiList = [] }) {
		return new Promise(resolve => {
			const arr = []
			if (menu) {
				menu.map(item => {
					if (!item.children) {
						arr.push(item)
					} else {
						item.children.map(item => {
							arr.push(item)
						})
					}
				})
			}

			// 左侧菜单一级菜单下的菜单项绑定页面注册组件
			const leftMenuBindComponent = arr => {
				// 判断是否是外部的菜单，如果是外部的则使用external组件
				arr.map(item => {
					if (item.children?.length > 0) {
						item.component = MiddleLayout
						leftMenuBindComponent(item.children)
					} else {
						// 判断是否为 V3 应用
						const isV3App = item.from === 3 ||
						                item.domain === '/v3' ||
						                item.path?.startsWith('/v3') ||
						                item.path?.startsWith('v3')

						if (isV3App) {
							item.component = () => import('@/views/v3-container/index')
						}
						// 如果标识为外部系统则进入外部系统页面
						else if (item.from == 2) {
							item.component = () => import('@/views/external/index')
						} else {
							item.component = mapRouter[item.name]
						}

						// 嵌入quick_bi系统需要根据/admin/v1/no_auth/quick_bi/list接口返回的字段统一更改路由信息component指向iframe页面
						if (item.domain === '/quick_bi' || item.domain === '/travelSys') {
							quickBiList.forEach(_item => {
								if (item.name === _item.meta_mark) {
									item.component = () => import('@/views/quick-bi-system/quick_bi')
								}
							})
						}
					}
				})
			}
			if (arr) {
				arr.map(item => {
					// 判断是否为 V3 应用（一级菜单）
					const isV3App = item.from === 3 ||
					                item.domain === '/v3' ||
					                item.path?.startsWith('/v3') ||
					                item.path?.startsWith('v3')

					// 如果是 V3 应用, 且没有子菜单，则需要创建一个子菜单使用Layout组件
					if (isV3App && !item.children) {
						item.component = Layout
						item.children = [
							{
								...item,
								component: () => import('@/views/v3-container/index')
							}
						]
					}
					// 如果是外部系统, 且没有子菜单，则需要创建一个子菜单使用Layout组件
					else if (item.from === 2 && !item.children) {
						item.component = Layout
						item.children = [
							{
								...item,
								component: () => import('@/views/external/index')
							}
						]
					} else {
						item.component = Layout
					}
					// 判断如果是有子菜单，
					if (item.children?.length > 0) {
						leftMenuBindComponent(item.children)
					}
				})
			}
			const accessedRoutes = arr || []

			accessedRoutes.push({ path: '*', redirect: '/404', hidden: true })
			commit('SET_ROUTES', accessedRoutes)
			resolve(accessedRoutes)
		})
	},
	clearRoutes({ commit }, route) {
		commit('SET_ROUTES', route)
	},
	// 获取按钮权限
	getPermissionButton({ commit, state }, id) {
		return new Promise(async resolve => {
			try {
				// 查看store里是否存在当前菜单id的按钮权限列表
				if (state.permissionButtonMap?.has(Number(id))) {
					console.log(`[V2 权限 Store] ✅ 菜单ID ${id} 的权限已缓存，权限点: [${state.permissionButtonMap.get(Number(id)).join(', ')}]`)
					resolve()
					return
				}
				// 通过接口获取权限列表
				console.log(`[V2 权限 Store] 📡 正在获取菜单ID ${id} 的权限...`)
				const { data = [] } = await getButtons(id)
				console.log(`[V2 权限 Store] 📦 API 返回权限点: [${data.map((btn) => btn.id || btn).join(', ')}]`)

				// 存入store
				commit('SET_PERMISSION_BUTTON_MAP', { id, data })
				console.log(`[V2 权限 Store] ✅ 菜单ID ${id} 的权限已存储到 Store 并同步到 Wujie props`)
				resolve()
			} catch (error) {
				console.error(`[V2 权限 Store] ❌ 获取菜单ID ${id} 的权限失败:`, error)
			}
		})
	},
  // 判断传入的ID是否存在权限列表中
  getPermissionButtonById({ state }, id) {
    return new Promise(resolve => {
      resolve(state.permissionButtonMap?.get(Number(id)) || [])
    })
  }
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
